// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").on("click", function () {
  var $body = $("body");
  var $nav = $(".main-nav-wrapper");
  var $list = $(".main-list-wrapper");

  var isOpen = $nav.toggleClass("open").hasClass("open");

  $list.removeClass("open");
  $("#btnList").removeClass("cross");

  $(this).toggleClass("cross", isOpen);
  $body.toggleClass("overflow", isOpen);
});

$("#btnList").on("click", function () {
  var $body = $("body");
  var $nav = $(".main-nav-wrapper");
  var $list = $(".main-list-wrapper");

  var isOpen = $list.toggleClass("open").hasClass("open");

  $nav.removeClass("open");
  $("#btnMobile").removeClass("cross");

  $(this).toggleClass("cross", isOpen);
  $body.toggleClass("overflow", isOpen);
});

$("#btnEye").on("click", function () {
  var $items = $(".content-fresque .content ul li");

  var isHidden = $items.toggleClass("hidden").hasClass("hidden");

  $(this).toggleClass("cross", isHidden);
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// MODAL
document.addEventListener('DOMContentLoaded', function () {

  var modal = document.getElementById('postModal');

  if (!modal) return;

  var baseUrl;
  var host = window.location.hostname;

  if (host === 'localhost') {
    baseUrl = 'http://localhost:3000/fresquelafayette/';
  }
  else if (host === 'beta.fresquelafayette.new.be') {
    baseUrl = 'https://beta.fresquelafayette.new.be/';
  }
  else {
    baseUrl = 'https://www.fresque.namur-lafayette.org/';
  }

  document.addEventListener('click', function (e) {

    var trigger = e.target;

    while (trigger && trigger !== document) {

      if (trigger.className && trigger.className.indexOf('js-open-modal') !== -1) {
        break;
      }

      trigger = trigger.parentNode;
    }

    if (!trigger || trigger === document) return;

    e.preventDefault();

    var id = trigger.getAttribute('data-id');
    var title = trigger.getAttribute('data-title');
    var image = trigger.getAttribute('data-image');
    var acftitle = trigger.getAttribute('data-acftitle');

    var titleEl = modal.querySelector('.modal-title');
    var imgEl = modal.querySelector('.modal-image');
    var excerptEl = modal.querySelector('.modal-excerpt');
    var contentEl = modal.querySelector('.modal-content-text');

    if (titleEl) titleEl.innerHTML = title || '';
    if (imgEl) imgEl.setAttribute('src', image || '');
    if (contentEl) contentEl.innerHTML = 'Chargement...';

    var xhr = new XMLHttpRequest();

    xhr.open('GET', baseUrl + 'wp-json/wp/v2/fresco/' + id, true);

    xhr.onreadystatechange = function () {

      if (xhr.readyState === 4) {

        if (xhr.status === 200) {

          var data = JSON.parse(xhr.responseText);

          if (titleEl) titleEl.innerHTML = data.title.rendered;
          if (excerptEl) {
            excerptEl.innerHTML = acftitle || '';
          }
          if (contentEl) contentEl.innerHTML = data.content.rendered;

        } else {

          if (contentEl) {
            contentEl.innerHTML = 'Erreur de chargement du contenu.';
          }

        }
      }

    };

    xhr.send();

  });

});

// ###########################################################################
// SLICK - slideshow & slider
// ✅ PROTÉGÉ: initialiser SEULEMENT si Slick existe
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.slideshow .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      cssEase: 'ease',
      fade: true,
      speed: 1000,
    });

  });
}